export enum LoginStepEnum {
  PRE_LOGIN = 'PRE_LOGIN',
  SENHA = 'SENHA',
  RECUSADO = 'RECUSADO',
  CADASTRO = 'CADASTRO',
}
